import styled, { keyframes, css } from "styled-components";
import { rgba } from "polished";

import { colors, typography } from "src/assets/styles/settings";
import { LabelProps } from ".";

const typeColors = {
  orange: colors.flip_orange,
  blue: colors.intel_blue,
  green: colors.jade,
  grey: colors.dark_grey,
  red: colors.ketchup_tomato,
  yellow: colors.mango_yellow,
  "dark-yellow": colors.goldenrod
} as const;

const backgroundMove = keyframes`
  0% {
    background-position: 100%;
  }

  100% {
    background-position: -100%;
  }
`;

function getBackground(color: keyof typeof typeColors, shimmer: boolean) {
  const pickedColor = typeColors[color];

  if (!shimmer) {
    return css`
      background: ${pickedColor};
    `;
  }

  return css`
    background: linear-gradient(90deg, ${pickedColor} 0%, ${rgba(pickedColor, 0.6)} 29.51%, ${pickedColor} 83.33%);
    animation: ${backgroundMove} 1s infinite;
    background-size: 200%;
  `;
}

const BaseLabel = styled.div<Pick<LabelProps, "color" | "shimmer">>`
  ${({ color, shimmer }) => getBackground(color, shimmer)}
  box-sizing: border-box;
  color: ${colors.white};
  display: inline-block;
  font-weight: ${typography.font_weight.bold};
  line-height: ${typography.line_height};
  text-transform: uppercase;
  white-space: nowrap;
`;

export const DefaultLabel = styled(BaseLabel)`
  border-radius: 20px;
  font-size: ${typography.font_size.label};
  line-height: 9px;
  padding: 2px 4px;
`;

export const LargeLabel = styled(BaseLabel)`
  border-radius: 40px;
  font-size: ${typography.font_size.semi};
  font-weight: ${typography.font_weight.normal};
  height: 25px;
  padding: 3px 8px;
`;
